export default "__VITE_ASSET__D1nruMJP__"